import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import React from "react";

interface CommonSearchProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  placeholder?: string;
}

export default function CommonSearch({
  onChange,
  value,
  placeholder = "Search",
}: CommonSearchProps) {
  return (
    <Input
      prefix={<SearchOutlined />}
      placeholder={placeholder}
      className="searchbar"
      onChange={onChange}
      value={value}
      style={{ width: 250 }}
    />
  );
}
